export const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 2800 },
      items: 5,
      slidesToSlide: 2,
    },
    LargeDesktop: {
      breakpoint: { max: 2800, min: 1024 },
      items: 4,
      slidesToSlide: 2,
    },
    desktop: {
      breakpoint: { max: 1024, min: 800 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 800, min: 480 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 480, min: 0 },
      items: 1,
    },
  };
  
  export const productData = [
    {
      id: "1Bikinidospiezas",
      imageurl:
      'https://res.cloudinary.com/dvjmjujc0/image/upload/v1692992050/bikini2cruzado_jtlclq.webp',
      name: "Bikini 2 piezas",
      price: "$4200",
      description: "bikinis",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 1,2,3 ], 
      idTalla: 101,
    },
    {
      id: "2VestidoescoteenV",
      imageurl:
        "https://res.cloudinary.com/dvjmjujc0/image/upload/v1692991351/vestidoenv_fi6ty7.webp",
      name: "Vestido escote en V",
      price: "$3700",
      description: "vestidos",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2,3 ],
      idTalla: 102,
    },
    {
      id: "3Musculosacuelloalto",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_776664-MLA52841947038_122022-W.webp",
      name: "Musculosa cuello alto",
      price: "$2500",
      description: "tops",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4 ],
      idTalla: 103,
    },
    {
      id: "4Topcorset",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_880630-MLA52221388211_102022-W.webp",
      name: "Top corset",
      price: "$5300",
      description: "tops",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2, 3 ],
      idTalla: 104,
    },
    {
      id: "5Faldadejeanconbolsillos",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_739178-MLA52161304862_102022-W.webp",
      name: "Falda de jean con bolsillos",
      price: "$6000",
      description: "bottoms",
      color: "jean",      
      IsTalla: "Talla",
      tallas: [ 2, 3, 4 ],
      idTalla: 105,
    },
    {
      id: "6Faldaconcortelateral",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_825458-MLA52700978401_122022-W.webp",
      name: "Falda con corte lateral",
      price: "$5000",
      description: "bottoms",
      color: "black",       
      IsTalla: "Talla",
      tallas: [ 1,2 ],
      idTalla: 106,
    },
    {
      id: "7Sombreroplayero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_745482-MLA48632045940_122021-W.webp",
      name: "Sombrero playero",
      price: "$3000",
      description: "accesorios",
      color: 'brown',
      tallas: [1,2],
      idTalla: 107,
    },
    {
      id: "8Vestidoplayero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_990049-MLA53210605030_012023-W.webp",
      name: "Vestido playero ",
      price: "$7000",
      description: "vestidos",
      color: "white",
      IsTalla: "Talla",
      tallas: [ 2,3,4 ],
      idTalla: 108,
    },
  ];